import { SESSION_STATE } from "./sessionLifecycle";
import { getCookie } from "../utilities/cookies";
const API = process.env.REACT_APP_ACCOUNTS_API || "https://api.accounts.clikkle.com/api";
export const clearLocalIdentity = () => {
  ["user","token","refreshToken","sessionToken"].forEach((key)=>localStorage.removeItem(key));
  document.cookie.split(";").forEach((cookie)=>{
    const name=cookie.split("=")[0].trim();
    if (/token|user|session|refresh/i.test(name)) document.cookie=`${name}=; Max-Age=0; path=/`;
  });
};
export async function validateCentralSession(){
  const refreshToken=(localStorage.getItem("refreshToken") || getCookie("refreshToken"))?.replace(/^"|"$/g,"");
  if(refreshToken && !localStorage.getItem("refreshToken")) localStorage.setItem("refreshToken", refreshToken);
  if(!refreshToken) return SESSION_STATE.INACTIVE;
  try{
    const response=await fetch(`${API}/auth/session/status`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({refreshToken,client_id:"store"})});
    const data=await response.json().catch(()=>({}));
    if(!response.ok || !(data?.success || data?.active===true)) return SESSION_STATE.INACTIVE;
    return SESSION_STATE.ACTIVE;
  }catch{return SESSION_STATE.UNVERIFIABLE;}
}
